export const getSchoolCurriculum = (year) => {
    switch (year) {
        case 100: // Toddlers
        case 101: // Nursery
        case 102: // Reception
            return 'Early Years';

        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
            return 'Primary School';

        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
            return 'Secondary School';

        default:
            return 'Upper Senior School';
    }
};

export const prepareYearOfStudying = (yearOfStudying) => {
    if (!yearOfStudying) {
        return '';
    }

    switch (yearOfStudying) {
        case 100:
            return 'Toddlers';

        case 101:
            return 'Nursery';

        case 102:
            return 'Reception';

        default:
            return `Year ${yearOfStudying}`;
    }
};
